document.addEventListener("DOMContentLoaded", function () {
  // window.onload = function() {
  var atTitles = document.querySelectorAll(".acctitle");
  atTitles.forEach(function (atTitle) {
    atTitle.addEventListener("click", function () {
      var atTab = this.nextElementSibling;
      var isActive = this.classList.contains("active");

      // Collapse all accordion tabs
      var parent = this.parentElement;
      var siblings = parent.parentNode.children;
      for (var i = 0; i < siblings.length; i++) {
        var siblingTab = siblings[i].querySelector(".acccontent");
        siblingTab.style.maxHeight = null;
        siblings[i].querySelector(".acctitle").classList.remove("active");
        siblings[i].classList.remove("currentopen"); // Remove active class from parent
      }

      // Toggle current accordion tab
      if (!isActive) {
        this.classList.add("active");
        parent.classList.add("currentopen"); // Add active class to parent
        atTab.style.maxHeight = atTab.scrollHeight + "px";
      }
    });
  });

  /* home banner start */

  var homebannertwo = new Swiper(".home-banner-slider-full", {
    direction: "vertical",
    effect: "slide",
    speed: 20000,
    slidesPerView: 2,
    spaceBetween: 3,
    loop: true,
    autoplay: {
      delay: 1,
      // reverseDirection: false,
      disableOnInteraction: false,
    },
    breakpoints: {
      575: {
        slidesPerView: 1,
        spaceBetween: 5,
        loop: true,
      },
    },
  });

  var homebanner = new Swiper(".reverse-direction", {
    direction: "vertical",
    effect: "slide",
    speed: 18000,
    slidesPerView: 2,
    spaceBetween: 3,
    loop: true,
    autoplay: {
      delay: 1,
      reverseDirection: true,
      disableOnInteraction: false,
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
    },
  });

  var homebannerlast = new Swiper(".home-banner-slider", {
    direction: "vertical",
    effect: "slide",
    speed: 20000,
    slidesPerView: 2,
    spaceBetween: 3,
    loop: true,
    autoplay: {
      delay: 1,
      reverseDirection: false,
      disableOnInteraction: false,
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
    },
  });

  /* home banner end */

  var jogasecslider = new Swiper(".joga-sec-slider", {
    speed: 3000,
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: false,
        centeredSlides: false,
      },
      0: {
        slidesPerView: 2.5,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
      },
    },
    on: {
      slideChange: function () {
        setTimeout(function () {
          updateActiveClass();
        }, 2000);
      },
      init: function () {
        setTimeout(function () {
          updateActiveClass();
        }, 2000);
      },
    },
  });

  function updateActiveClass() {
    var slides = document.querySelectorAll(".joga-sec-slider .swiper-slide");
    slides.forEach(function (slide) {
      slide.classList.remove("active");
    });
    var activeSlide = document.querySelector(
      ".joga-sec-slider .swiper-slide.swiper-slide-active"
    );
    if (activeSlide) {
      activeSlide.classList.add("active");
    }
  }

  // approved-slider slider
  var approvedslider = new Swiper(".approved-slider", {
    navigation: {
      nextEl: ".switchslider-next",
      prevEl: ".switchslider-prev",
    },
    loop: true,
    centeredSlides: false,
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 15,
        loop: false,
      },
      600: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
      },
    },
  });
  // hallbanner slider
  var hallslider = new Swiper(".hall-slider", {
    centeredSlides: true,
    navigation: {
      nextEl: ".hallslider-next",
      prevEl: ".hallslider-prev",
    },
    loop: true,
    slidesPerView: 2,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 25,
        centeredSlides: false,
        loop: false,
        scrollbar: {
          el: ".hall-scroll",
          draggable: true,
        },
      },
      0: {
        slidesPerView: 2.5,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".hall-dots",
          clickable: true,
        },
      },
    },
  });
  // switch-joga-sec slider
  var switchjogaslider = new Swiper(".switch-joga-slider", {
    loop: true,
    navigation: {
      nextEl: ".switchslider-next",
      prevEl: ".switchslider-prev",
    },
    slidesPerView: 2,
    paginationClickable: true,
    spaceBetween: 32,
    scrollbar: {
      el: ".switchjoga-scroll",
      draggable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
        loop: false,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
      },
    },
  });
  // Video Slider Section
  var jogasvideolider = new Swiper(".video-review-slider", {
    loop: true,
    navigation: {
      nextEl: ".videoslider-next",
      prevEl: ".videoslider-prev",
    },
    slidesPerView: 2,
    paginationClickable: true,
    spaceBetween: 32,
    scrollbar: {
      el: ".videojoga-scroll",
      draggable: true,
    },
    breakpoints: {
      1024: {
        loop: true,
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
      },
    },
  });
  // Tab Slider Home page
  var tab_slider = new Swiper(".featured-tab-slider", {
    loop: true,
    navigation: {
      nextEl: ".swiper-tab-next",
      prevEl: ".swiper-tab-prev",
    },
    scrollbar: {
      el: ".swiper-tab-scrollbar",
      draggable: true,
    },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  // you may also like
  var featured_also_like_slider = new Swiper(".featured-also-like-slider", {
    loop: true,
    navigation: {
      nextEl: ".swiper-also-like-next",
      prevEl: ".swiper-also-like-prev",
    },
    scrollbar: {
      el: ".swiper-also-like-scrollbar",
      draggable: true,
    },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  // Review Style 1
  var reviewsliderstyle1 = new Swiper(".review-slider-style-1", {
    loop: true,
    navigation: {
      nextEl: ".reviewstyle1slider-next",
      prevEl: ".reviewstyle1slider-prev",
    },
    slidesPerView: 2,
    paginationClickable: true,
    spaceBetween: 19,
    scrollbar: {
      el: ".reviewstyle1slider-scroll",
      draggable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        loop: true,
      },
      768: {
        slidesPerView: 2,
        loop: false,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 10,
        centeredSlides: true,
      },
    },
  });
  
  console.log('78798794632163465')
  const announement_slider = new Swiper(".top-announcement-bar .text-slider-row", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 3000,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  // Textslider Style 1
  var reviewsliderstyle1 = new Swiper(".text-slider-sec .text-slider-row", {
    loop: true,
    navigation: {
      nextEl: ".textslider-next",
      prevEl: ".textslider-prev",
    },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 10,
    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
      },
    },
  });

  $(document).on("change", ".option_item input", function (e) {
    var main_div = $(this).parents(".free_product_js");
    var size = main_div.find(".options_flex").eq(0).find("input:checked").val();
    var color = main_div
      .find(".options_flex")
      .eq(1)
      .find("input:checked")
      .val();
    var title = size + " / " + color;
    main_div.find('select[name="variant_id"] option').each(function () {
      var loop_title = $(this).text();
      if (loop_title == title) {
        var id = $(this).val();
        main_div.find('select[name="variant_id"]').val(id);
        main_div.find('select[name="variant_id"]').trigger("change");
      }
    });
  });
  $(document).on("change", 'select[name="variant_id"]', function (e) {
    var id = jQuery(this).val();
    var current_id = jQuery(this).attr("current_id");
    var line = jQuery(this).attr("line");
    var quantity = jQuery(this).attr("quantity");
    var remove_link = jQuery(this).attr("remove_link");
    $(this)
      .parents(".cart-item")
      .find(".loading__spinner")
      .removeClass("hidden");
    jQuery.ajax({
      type: "POST",
      url: remove_link,
      success: function () {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: id,
          },
          dataType: "json",
          success: function (data) {
            jQuery("cart-drawer").load(location.href + " #CartDrawer");
            setTimeout(function () {
              jQuery("cart-drawer").removeClass("is-empty").addClass("active");
              jQuery("body ").addClass("overflow-hidden");
            }, 500);
          },
        });
      },
      error: function () {},
    });
  });
  $(document).on("click", "body .footer-sec .footer-inner h3", function (e) {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });

  $(document).on(
    "click",
    ".custom_drawer_products_item_buy_box .add_to_cart_ajax",
    function (e) {
      e.preventDefault();
      var id = $(this)
        .parents(".custom_drawer_products_item_buy_box")
        .find('select[name="variant_id_custom"]')
        .val();
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: id,
        },
        dataType: "json",
        success: function (data) {
          jQuery("cart-drawer").load(location.href + " #CartDrawer");
          setTimeout(function () {
            jQuery("cart-drawer").removeClass("is-empty").addClass("active");
            jQuery("body ").addClass("overflow-hidden");
          }, 500);
        },
      });
    }
  );

  $(document).on("click", ".custom_button .add_to_cart_ajax", function (e) {
    e.preventDefault();
    var id = $(this).attr("variant_id");
    var this_element = jQuery(this);
    this_element.addClass("loading_hk");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: id,
      },
      dataType: "json",
      success: function (data) {
        jQuery("cart-drawer").load(location.href + " #CartDrawer");
        setTimeout(function () {
          jQuery("cart-drawer").removeClass("is-empty").addClass("active");
          jQuery("body ").addClass("overflow-hidden");
          this_element.removeClass("loading_hk");
        }, 500);
      },
    });
  });

  $(document).on("change", ".product_option_select select", function (e) {
    e.preventDefault();
    var id = $(this).val();
    var this_element = jQuery(this);
    this_element.prev().addClass("loading_hk");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: id,
      },
      dataType: "json",
      success: function (data) {
        jQuery("cart-drawer").load(location.href + " #CartDrawer");
        setTimeout(function () {
          jQuery("cart-drawer").removeClass("is-empty").addClass("active");
          jQuery("body ").addClass("overflow-hidden");
          this_element.prev().removeClass("loading_hk");
          this_element.val("");
        }, 500);
      },
    });
  });
});

$(document).on("click", 'a[href="#"]', function (e) {
  e.preventDefault();
});

/* Tab section */
// document.addEventListener("DOMContentLoaded", function() {
//     // Select all <a> elements with the class .tab-title inside .featured-tab-row
//     var tabTitles = document.querySelectorAll('.featured-tab-row .tab-title');
//     // Loop through each element
//     tabTitles.forEach(function(element) {
//         // Add blank space after each <a> element
//         var spaceNode = document.createTextNode(' ');  // Create a text node with a space
//         element.parentNode.insertBefore(spaceNode, element.nextSibling); // Insert the space after the <a> tag
//         // Add the 'hidden' class to the element
//         element.classList.add('hidden');
//     });
// });

// document.addEventListener("DOMContentLoaded", function() {
//     // Select all elements with the class .tab-title and .hidden
//     var hiddenTabTitles = document.querySelectorAll('.tab-title.hidden');

//     // Loop through each selected element
//     hiddenTabTitles.forEach(function(tabTitle) {
//         // Find the closest ancestor with the class .featured-pdp-collection
//         var parentCollection = tabTitle.closest('.featured-pdp-collection');

//         // If a parent collection is found, find all .tab-content-block elements within it
//         if (parentCollection) {
//             var tabContentBlocks = parentCollection.querySelectorAll('.tab-content-block');

//             // Add 'active' class to each found .tab-content-block element
//             tabContentBlocks.forEach(function(block) {
//                 block.classList.add('active');
//             });
//         }
//     });
// });

/* id wise scrolliing pdp faq section */
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".faq-section-block-tab")
    .forEach(function (element) {
      // Add click event listener
      element.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default action
        e.stopPropagation(); // Stop event propagation

        // Retrieve the href attribute and remove the leading "#"
        var href = element.getAttribute("href").substring(1); // Remove the leading "#"
        console.log(href); // Log the result

        // Find the section with the matching id
        var targetSection = document.querySelector(
          '.faqs-sec.accordian_tab [id="' + href + '"]'
        );
        if (targetSection) {
          // Get the position of the target section relative to the top of the document
          var targetPosition = targetSection.offsetTop;

          // Adjust the position by subtracting 100px to account for the offset
          var offsetPosition = targetPosition - 100;

          // Smoothly scroll to the adjusted position
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth", // Smooth scrolling
          });

          // Add the "active" class to the target section
          targetSection.classList.add("active");

          // Optionally, remove "active" class from other sections (if you want only one active section at a time)
          document
            .querySelectorAll(".faqs-sec.accordian_tab .faq-section")
            .forEach(function (section) {
              if (section !== targetSection) {
                section.classList.remove("active");
              }
            });
        }
      });
    });
});
